import { Button, Typography } from "@mui/material";
import { Vocabulary } from "../Utils/Vocabulary";
import styles from "./AppErrorBoundary.module.css";

export default function AppErrorPage() {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className={styles.container}>
      <img src={"/pageNotFound.svg"} alt="error" className={styles.image} />
      <Typography className={styles.title}>
        {Vocabulary.appErrorTitle}
      </Typography>
      <Typography className={styles.message}>
        {Vocabulary.appErrorMessage}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        className={styles.button}
        onClick={handleReload}
      >
        {Vocabulary.appErrorReload}
      </Button>
    </div>
  );
}
